import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    Filler,
} from 'chart.js';
import ChartjsPluginStacked100 from 'chartjs-plugin-stacked100';

export const init = () => {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        LineElement,
        PointElement,
        Title,
        Tooltip,
        Legend,
        Filler,
        ArcElement,
        ChartjsPluginStacked100,
    );
};
